import React from "react";
import {
  IssueBulkEditPanel,
  BulkEditPanelProps,
} from "../../IssueBulkEditPanel";
import { getIssuesByIds } from "@adsk/acc-issues-core/state/redux/ducks/issuesCollection";
import { getIssueTableSelectedIds } from "@adsk/acc-issues-core/state/redux/ducks/issueTableSelection";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";

/**
 *
 * the bulk edit panel takes any list of issues so it isn't tied to the log context,
 * so we do a little hydration on it to get the selected issues.
 */
export const HydratedBulkEditPanel = (
  bulkEditPanelProps: Omit<BulkEditPanelProps, "issues">
) => {
  const issueUids = useSelector(getIssueTableSelectedIds);
  const issues = useSelector(getIssuesByIds)(issueUids);
  return <IssueBulkEditPanel {...bulkEditPanelProps} issues={issues} />;
};
